import CommonCodeView from "./common-code.view";

/**
 * Common Code (Country) View
 * 
 * Main code master page for subsidiary admins to easily add code into the database
 * 
 * @author CV Leong
 */
export default function CommonCodeSubsidiaryAdminView() {

  return {
    view: () => m(CommonCodeView)
  }
};
